import { Typography, Box } from '@mui/material';
import { FC } from 'react';

interface ShortDisclaimerProps {
  variant?: 'footer' | 'inline' | 'banner';
}

export const ShortDisclaimer: FC<ShortDisclaimerProps> = ({ variant = 'inline' }) => {
  const text = "Portfoliomatic does not provide investment, legal, or tax advice. All information is for educational purposes only. Trade decisions are solely the responsibility of the user.";

  const getStyles = () => {
    switch (variant) {
      case 'footer':
        return {
          fontSize: '0.75rem',
          color: 'text.secondary',
          textAlign: 'center' as const,
          mt: 1
        };
      case 'banner':
        return {
          fontSize: '0.875rem',
          color: 'warning.main',
          fontWeight: 'medium',
          textAlign: 'center' as const,
          p: 1,
          backgroundColor: 'warning.light',
          borderRadius: 1,
          mb: 2
        };
      default:
        return {
          fontSize: '0.875rem',
          color: 'text.secondary',
          fontStyle: 'italic'
        };
    }
  };

  return (
    <Box sx={variant === 'banner' ? getStyles() : {}}>
      <Typography 
        variant="body2" 
        sx={variant !== 'banner' ? getStyles() : {}}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default ShortDisclaimer;